__turbopack_context__.v({
  "button-loading-fill": "button-module-scss-module__E2Om_G__button-loading-fill",
  "destructive": "button-module-scss-module__E2Om_G__destructive",
  "fullWidth": "button-module-scss-module__E2Om_G__fullWidth",
  "ghost": "button-module-scss-module__E2Om_G__ghost",
  "icon": "button-module-scss-module__E2Om_G__icon",
  "label": "button-module-scss-module__E2Om_G__label",
  "lg": "button-module-scss-module__E2Om_G__lg",
  "link": "button-module-scss-module__E2Om_G__link",
  "loading": "button-module-scss-module__E2Om_G__loading",
  "md": "button-module-scss-module__E2Om_G__md",
  "naked": "button-module-scss-module__E2Om_G__naked",
  "primary": "button-module-scss-module__E2Om_G__primary",
  "root": "button-module-scss-module__E2Om_G__root",
  "secondary": "button-module-scss-module__E2Om_G__secondary",
  "sm": "button-module-scss-module__E2Om_G__sm",
  "tag": "button-module-scss-module__E2Om_G__tag",
});
